<template>
  <th
    class="t-table__head"
    :class="[
      `t-table__head--${contentAlign}`,
    ]">
    <slot></slot>
  </th>
</template>

<script>
import TableCellMixin from '../../mixins/TableCellMixin';

export default {
  name: 't-table-head',
  mixins: [TableCellMixin],
};
</script>
